<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>MOT DU DIRECTEUR EXECUTIF</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>MOT DU DIRECTEUR EXECUTIF</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Director Profile Section -->
<section class="director-profile-section pt-100 pb-170">
    <div class="container">
        <div class="profile-container">
            <div class="profile-image">
                <div class="image-wrapper">
                    <img src="assets/img/directeur-executif/doumbouya.jpeg" alt="Directeur Exécutif BSTP" class="director-photo">
                    <div class="image-overlay">
                        <div class="overlay-content">
                            <i class="icofont-quote-left"></i>
                        </div>
                    </div>
                </div>
                <div class="profile-badge">
                    <i class="icofont-star"></i>
                    <span>Directeur Exécutif</span>
                </div>
            </div>
            
            <div class="profile-content">
                <div class="director-info">
                    <h2 class="director-name">Alpha Bacar Bela DOUMBOUYA</h2>
                    <p class="director-title">Directeur Exécutif</p>
                    <p class="director-subtitle">Bourse des Sous-Traitance et de Partenariats de Guinée</p>
                    
                    <div class="director-stats">
                        <div class="stat-item">
                            <div class="stat-number">15+</div>
                            <div class="stat-label">Années d'Expérience</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">500+</div>
                            <div class="stat-label">Projets Accomplis</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">3000+</div>
                            <div class="stat-label">Partenariats Signés</div>
                        </div>
                    </div>
                </div>
                
                <div class="director-message">
                    <div class="message-header">
                        <i class="icofont-quote-left"></i>
                        <h3>Mot de bienvenue du Directeur Exécutif</h3>
                    </div>
                    
                    <div class="message-content">
                        <p class="message-text">
                            Bienvenue sur le site officiel de la Bourse de Sous-Traitance et de Partenariats (BSTP) de Guinée.
                            Vous êtes ici dans un espace dédié à la promotion des compétences, des talents et du savoir-faire local.
                        </p>
                        
                        <p class="message-text">
                            Depuis sa création, la BSTP œuvre à un objectif ambitieux mais essentiel : faire en sorte que les entreprises guinéennes prennent pleinement part à la dynamique économique de notre pays.
                            Dans un contexte marqué par de grands projets structurants, notamment dans les secteurs des mines, de l’énergie, des infrastructures et de l’agro-industrie, notre rôle est d’accompagner les PME à gagner en visibilité, en compétitivité et en accès aux marchés.
                        </p>
                        
                        <p class="message-text">
                            À la BSTP, nous croyons que le développement économique passe par des partenariats solides, une meilleure organisation des chaînes de valeur et un investissement continu dans la qualité et l’innovation.
                            C’est pourquoi nous vous offrons ici un point d’entrée unique vers un réseau d’opportunités, de formations, d’outils pratiques et de contacts utiles pour faire avancer vos projets.
                        </p>
                        
                        <p class="message-text">
                            Que vous soyez une entreprise locale à la recherche de débouchés, un grand donneur d’ordres à la recherche de fournisseurs fiables, ou un partenaire engagé pour le développement du secteur privé, vous êtes au bon endroit.
                            Notre équipe est mobilisée pour faire de chaque connexion une opportunité concrète.
                        </p>
                        
                        <div class="message-signature">
                            <p class="signature-text">Bienvenue chez vous, à la BSTP.</p>
                            <p class="signature-name">Alpha Bacar Bela DOUMBOUYA</p>
                            <p class="signature-title">Directeur Exécutif, BSTP</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Social Share Section -->
<section class="social-share-section">
    <div class="container">
        <div class="share-content">
            <h3 class="share-title">Partagez ce message</h3>
            <p class="share-subtitle">Aidez-nous à diffuser la vision du Directeur Exécutif</p>
            
            <div class="share-buttons">
                <button class="share-btn share-facebook" (click)="shareOnFacebook()">
                    <i class="icofont-facebook"></i>
                    <span>Facebook</span>
                </button>
                
                <button class="share-btn share-twitter" (click)="shareOnTwitter()">
                    <i class="icofont-twitter"></i>
                    <span>Twitter</span>
                </button>
                
                <button class="share-btn share-linkedin" (click)="shareOnLinkedIn()">
                    <i class="icofont-linkedin"></i>
                    <span>LinkedIn</span>
                </button>
                
                <button class="share-btn share-whatsapp" (click)="shareOnWhatsApp()">
                    <i class="icofont-whatsapp"></i>
                    <span>WhatsApp</span>
                </button>
                
                <button class="share-btn share-email" (click)="shareByEmail()">
                    <i class="icofont-email"></i>
                    <span>Email</span>
                </button>
                
                <button class="share-btn share-copy" (click)="copyLink()">
                    <i class="icofont-copy"></i>
                    <span>Copier le lien</span>
                </button>
            </div>
        </div>
    </div>
</section>

<!-- Vision Section -->
<section class="director-vision-section">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Notre Vision</h2>
            <p class="section-subtitle">
                La vision du Directeur Exécutif pour l'avenir de la BSTP et de la Guinée
            </p>
        </div>
        
        <div class="vision-grid">
            <div class="vision-card">
                <div class="card-icon">
                    <i class="icofont-globe"></i>
                </div>
                <h3 class="card-title">Hub Économique Régional</h3>
                <p class="card-description">
                    Faire de la Guinée un centre économique majeur en Afrique de l'Ouest, 
                    attirant investissements et partenariats internationaux.
                </p>
            </div>
            
            <div class="vision-card">
                <div class="card-icon">
                    <i class="icofont-news"></i>
                </div>
                <h3 class="card-title">Innovation & Technologie</h3>
                <p class="card-description">
                    Promouvoir l'adoption des technologies émergentes et l'innovation 
                    dans tous les secteurs d'activité.
                </p>
            </div>
            
            <div class="vision-card">
                <div class="card-icon">
                    <i class="icofont-users-alt-4"></i>
                </div>
                <h3 class="card-title">Emploi & Formation</h3>
                <p class="card-description">
                    Créer des emplois durables et former les jeunes aux métiers 
                    de demain pour un développement inclusif.
                </p>
            </div>
            
            <div class="vision-card">
                <div class="card-icon">
                    <i class="icofont-leaf"></i>
                </div>
                <h3 class="card-title">Développement Durable</h3>
                <p class="card-description">
                    Privilégier des solutions durables et respectueuses de 
                    l'environnement dans tous nos projets.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- Achievements Section -->
<section class="director-achievements-section">
    <div class="container">
        <div class="achievements-content">
            <div class="achievements-header">
                <h2 class="achievements-title text-white">Réalisations Sous Sa Direction</h2>
                <p class="achievements-subtitle">
                    Les succès et accomplissements majeurs de la BSTP depuis sa nomination
                </p>
            </div>
            
            <div class="achievements-timeline">
                <div class="timeline-item">
                    <div class="timeline-year">2023</div>
                    <div class="timeline-content">
                        <h3>Lancement du Programme d'Innovation</h3>
                        <p>Mise en place d'un programme d'accompagnement pour 200 PME dans leur transformation numérique.</p>
                    </div>
                </div>
                
                <div class="timeline-item">
                    <div class="timeline-year">2022</div>
                    <div class="timeline-content">
                        <h3>Partenariats Internationaux</h3>
                        <p>Signature de 25 partenariats stratégiques avec des entreprises internationales.</p>
                    </div>
                </div>
                
                <div class="timeline-item">
                    <div class="timeline-year">2021</div>
                    <div class="timeline-content">
                        <h3>Expansion Régionale</h3>
                        <p>Ouverture de 3 bureaux régionaux pour mieux servir les entreprises locales.</p>
                    </div>
                </div>
                
                <div class="timeline-item">
                    <div class="timeline-year">2020</div>
                    <div class="timeline-content">
                        <h3>Digitalisation des Services</h3>
                        <p>Lancement de la plateforme numérique BSTP pour faciliter les échanges B2B.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Contact Section -->
<section class="director-contact-section">
    <div class="container">
        <div class="contact-content">
            <div class="contact-icon">
                <i class="icofont-envelope"></i>
            </div>
            <h2 class="contact-title">Contactez le Directeur Exécutif</h2>
            <p class="contact-subtitle">
                Vous souhaitez échanger avec le Directeur Exécutif ? N'hésitez pas à nous contacter.
            </p>
            <div class="contact-actions">
                <a routerLink="/contact" class="btn btn-primary">
                    <i class="icofont-phone"></i>
                    <span>Prendre Rendez-vous</span>
                </a>
                <a href="mailto:saifoulaye.balde@bstpgn.com" class="btn btn-outline-primary">
                    <i class="icofont-email"></i>
                    <span>Envoyer un Email</span>
                </a>
            </div>
        </div>
    </div>
</section>

